import { Pipe, PipeTransform } from '@angular/core';
import {TagTextData} from "./tag-text.component";

@Pipe({
  name: 'tagTextDefaultColor'
})
export class TagTextDefaultColorPipe implements PipeTransform {

  transform(tagTextData: TagTextData, defaultColor: string): TagTextData {
      return {
        color: defaultColor,
        ...tagTextData
      };
  }

}
